import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function Taxes() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Taxes</h1>
        <p className="text-muted-foreground mt-1">Tax reports and Schedule E preparation</p>
      </div>

      <Card className="shadow-soft">
        <CardHeader>
          <CardTitle>Tax Reports</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Tax reporting coming soon...</p>
        </CardContent>
      </Card>
    </div>
  );
}
